import React from 'react';
import ReactDOM from 'react-dom/client';
//import './index.css';
//import App from './App';
import './components/common/css/all.css';
//import './components/common/css/table_settings.css';
//import './components/common/css/other_settings.css';
import reportWebVitals from './reportWebVitals';

import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";

import Menu from "./components/applications/menu";
import Landing from "./components/applications/wlc/landing";
import SeasonList from "./components/applications/wlc/seasonlist";
import RecordListWrapper from "./components/applications/wlc/recordlistwrapper";
import PokerNow from "./components/applications/poker/pokernow";
import Restaurants from "./components/applications/restaurants/restaurants";
import Pools from "./components/applications/pools/pools";
import Cards from "./components/applications/cards/cards";
import { SendMessage } from "./components/applications/websockets/sendmessage";


const root = ReactDOM.createRoot(
	document.getElementById('root') as HTMLElement
);
root.render(
	<React.StrictMode>
		<BrowserRouter>
			<Routes>
				<Route path="menu" element={<Menu />} />
				<Route path="/" element={<Landing />} />
				<Route path="seasonlist" element={<SeasonList />} />
				<Route path="recordlist/:seasonId" element={<RecordListWrapper />} />
				<Route path="poker" element={<PokerNow />} />
				<Route path="restaurants" element={<Restaurants />} />
				<Route path="pools" element={<Pools />} />
				<Route path="cards" element={<Cards />} />
				<Route path="websockets" element={<SendMessage />} />
				<Route path="*" element={
						<main style={{ padding: "1rem" }}>
							<p>No route defined in index.tsx</p>
						</main>
					}
				/>
			</Routes>
		</BrowserRouter>
	</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
